import { createContext } from "react"

export const DragAnimationContext = createContext<boolean>(false)
